import { LocationOptionType } from 'components/LocationFilterInput/LocationFilterInput.types';
import { UseGQLQueryConfig } from 'hooks/useGQLQuery/useGQLQuery.types';
import { useUserTypeSwitch } from 'hooks/useUserTypeSwitch';
import { createApolloCache, createApolloClient } from 'providers/ApolloProvider';
import { QUERY_locationDropdownData } from 'queries';
import { LocationDropdownDataQuery, AgencyUser, B2bCustomer } from 'types/graphql';

export const getDefaultLocationDropdownValue = (options: LocationOptionType[]) => {
  if (options.length) {
    return options[0];
  }

  return undefined;
};

export const locationOptionsTransformer = (data?: LocationDropdownDataQuery) => {
  if (!data) return [];
  const me = data.me as B2bCustomer;
  const mapped: LocationOptionType[] = me?.communities.map(
    ({ displayId, name, location, hasMarketplace }) => {
      return {
        name: 'location',
        label: name,
        key: displayId,
        value: displayId,
        id: displayId,
        type: 'Standard',
        latitude: location?.latitude,
        longitude: location?.longitude,
        timeZone: location?.timeZone || undefined,
        country: location?.country || undefined,
        hasMarketplace,
      };
    },
  );

  return mapped;
};

export const agencyLocationOptionsTransformer = (data?: LocationDropdownDataQuery) => {
  if (!data) return [];

  const me = data.me as AgencyUser;

  const mapped: LocationOptionType[] = me.agency
    ? me?.agency?.agencyCommunities.map((community) => {
        const stringified = community!.id.toString();
        return {
          latitude: community.location?.latitude,
          longitude: community.location?.longitude,

          name: 'location',
          label: community!.name,
          key: stringified,
          value: stringified,
          id: stringified,
          type: 'Standard',
          timeZone: community?.location?.timeZone || undefined,
          country: community?.location?.country || undefined,
          hasMarketplace: false,
        };
      })
    : [];
  return mapped;
};

const client = createApolloClient({ cache: createApolloCache() });

export const useLocationFilterQueryConfig = (): UseGQLQueryConfig<
  LocationDropdownDataQuery,
  LocationOptionType[],
  {}
> => {
  return useUserTypeSwitch({
    B2B: {
      key: 'LOCATION_FILTER_B2B',
      query: QUERY_locationDropdownData,
      responseTransformer: locationOptionsTransformer,
      client,
    },
    Agency: {
      key: 'LOCATION_FILTER_AGENCY',
      query: QUERY_locationDropdownData,
      responseTransformer: agencyLocationOptionsTransformer,
      client,
    },
  });
};
